import { z } from 'zod';

export const createUserRequestSchema = z.object({
  fullName: z.string(),
  email: z.string(),
  roleIds: z.array(z.string()),
});

export const createUserResponseSchema = z.any();

export type CreateUserRequest = z.infer<typeof createUserRequestSchema>;

export const updateUserRequestSchema = z.object({
  fullName: z.string(),
  email: z.string(),
  roleIds: z.array(z.string()),
});

export const updateUserResponseSchema = z.any();

export type UpdateUserRequest = z.infer<typeof updateUserRequestSchema>;
export type UpdateUserResponse = z.infer<typeof updateUserResponseSchema>;

export const listSystemRolesResponseSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    isReadOnly: z.boolean(),
  })
);

export type ListSystemRolesResponse = z.infer<typeof listSystemRolesResponseSchema>;

export const organizationRolesDropdownResponseSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
  })
);

export type OrganizationRolesDropdownResponse = z.infer<typeof organizationRolesDropdownResponseSchema>;

export const activateUserRequestSchema = z.object({
  hash: z.string(),
  password: z.string(),
});

export const activateUserResponseSchema = z.any();

export type ActivateUserRequest = z.infer<typeof activateUserRequestSchema>;
export type ActivateUserResponse = z.infer<typeof activateUserResponseSchema>;

export const organizationUsersRequestSchema = z.object({
  searchText: z.string().optional(),
  roleIds: z.array(z.string()).optional(),
  status: z.enum(['Passive', 'Active']).optional(),
});

export const organizationUsersResponseSchema = z.array(
  z.object({
    id: z.string(),
    fullName: z.string(),
    email: z.string(),
    status: z.enum(['Passive', 'Active']),
    roles: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
      })
    ),
  })
);

export type OrganizationUsersRequest = z.infer<typeof organizationUsersRequestSchema>;
export type OrganizationUsersResponse = z.infer<typeof organizationUsersResponseSchema>;

export const sendActivationEmailRequestSchema = z.object({
  userId: z.string(),
});

export const sendActivationEmailResponseSchema = z.any();

export type SendActivationEmailRequest = z.infer<typeof sendActivationEmailRequestSchema>;
export type SendActivationEmailResponse = z.infer<typeof sendActivationEmailResponseSchema>;

export const sendResetPasswordMailRequestSchema = z.object({
  userId: z.string(),
});

export const sendResetPasswordMailResponseSchema = z.any();

export type SendResetPasswordMailRequest = z.infer<typeof sendResetPasswordMailRequestSchema>;
export type SendResetPasswordMailResponse = z.infer<typeof sendResetPasswordMailResponseSchema>;

export const deleteUserResponseSchema = z.any();

export type DeleteUserResponse = z.infer<typeof deleteUserResponseSchema>;

export const organizationUserDetailResponseSchema = z.object({
  id: z.string().nullable(),
  fullName: z.string().nullable(),
  email: z.string().nullable(),
  roles: z.array(
    z.object({
      id: z.string().nullable(),
      name: z.string().nullable(),
    })
  ),
});

export type OrganizationUserDetailResponse = z.infer<typeof organizationUserDetailResponseSchema>;
